import { useCallback } from 'react';
import { EditingToolName } from '../../../containers/Home/Home.types';
import { bi } from '../../../services/loggers/bi';
import { homeEditingToolsClick } from '@wix/bi-logger-media-data/v2';

export const useTrackOpenEditingTools = () => {
  const trackOpenEditingTools = useCallback((buttonName: EditingToolName) => {
    bi.logger().report(
      homeEditingToolsClick({
        button_name: buttonName,
      }),
    );
  }, []);

  const trackVideoMakerOpen = useCallback(() => {
    trackOpenEditingTools(EditingToolName.VideoMaker);
  }, []);

  const trackMediaStudioOpen = useCallback(() => {
    trackOpenEditingTools(EditingToolName.PhotoStudio);
  }, []);

  return { trackVideoMakerOpen, trackMediaStudioOpen };
};
